// extracted by mini-css-extract-plugin
export default {"rerollForm":"AbilitiesForm_rerollForm__gBZgd","rerollFormInputGroup":"AbilitiesForm_rerollFormInputGroup__4C6jt","surgeForm":"AbilitiesForm_surgeForm__LjhzI"};